import Swal from "sweetalert2"

export const SwallTimer = (timer) => {
    Swal.fire({
        title: 'Enviando Correo',
        text: `En breves recibiras un correo de contestacion`,
        timer,
        didOpen: () => {
            Swal.showLoading()
        }
    })
}